import axios from 'axios';
import qs from 'qs';
function createDefaultRequest(baseURL) {
    const instance = axios.create({
        baseURL,
        timeout: 1000*60,

    });
    instance.interceptors.request.use(config=>{
      config.data = qs.stringify(config.data);
      return config;
    });
    instance.interceptors.response.use(response=>{
        const data = response.data;
        if(data && data.status !== 200){
            const error = {
                code:data.status,
                message:data.message,
                response,
                type:'RequestError'
            };
            return Promise.reject(error);
        }
        return data;
    },(r)=>{
        if(r instanceof Error){
            return Promise.reject({
                code:r.code,
                message:r.message,
                type:'RequestError'
            });
        }
        const response = r.response;
        const status = response.status;
        const error = {
            message:`[${status}]${response.statusText}`,
            code:status,
            response,
            type:'RequestError'
        };
        return Promise.reject(error);
    });
    return instance;
}

export default createDefaultRequest;
